import { Activity, GraphGroup, GraphStyle, GROUP_SHOW_TYPE } from "components/planner/types"
import { groupsGetHeight } from "components/planner/utils"
import { KonvaEventObject } from "konva/lib/Node"
import { ReactNode } from "react"
import { Group } from "react-konva"
import { DateNumber } from "types/global"
import GridBG from "../GridBG"
import GridBGCompact from "../GridBGCompact"
import Header from "../Header"
import LayoutCollection from "../layout/LayoutCollection"
import ListLabelsVert from "../ListLabelsVert"
import Activities from "./Activities"



function GraphGroupCmp({
	group,
	start,
	style,
	activityHighlight,
	activitySelect,
	x,
	y,
	deep = 0,
	areaHeight,

	onGroupChange,
	onActivityEnter,
	onActivityLeave,
	onActivityClick,
	onActivityDoubleClick,

	HeaderRender,
	RenderLeaf,
}: GraphGroupProps) {

	const handleGroupChange = (newGroup: GraphGroup, index: number) => {
		group.groups[index] = newGroup
		onGroupChange(group)
	}

	const width = style.columns * style.space.x
	//const height = groupsGetHeight (group, style)

	// per questioni di praticità metto un numero molto elevato altrimenti dovrei calcolare l'altezza reale di tutte le ACTIVITIES
	// non utilizzare INFINITE!
	const clipHead = 80000

	return <>
		<LayoutCollection x={x} y={y} height={areaHeight}>

			<Header
				title={group.title}
				group={group}
				onGroupChange={onGroupChange}
				deep={deep}
				style={style}
				fixed={group.name == "planner_root"}
			/>

			{/* tipicamente un Histogram */}
			{!group.collapsed && HeaderRender(group)}

			{!group.collapsed && (

				// È UNA "LEAF"
				group.groups == null ? (
					group.show == GROUP_SHOW_TYPE.COMPACT ? (
						<Group
							// mi permette di rientrare nell'HEADER le ACTIVITIES compatte
							y={-Header.CalcHeight({ style }) - .5} x={-.5}
						>
							<GridBGCompact
								columns={style.columns}
								rows={group.labels.length}
								style={style}
							/>
							<Activities
								clip={{ x: 0, y: 0, width: width, height: clipHead }}
								start={start}
								showType={group.show}
								activities={group.activities}
								activityHighlight={activityHighlight}
								activitySelect={activitySelect}
								onActivityEnter={onActivityEnter}
								onActivityLeave={onActivityLeave}
								onActivityClick={onActivityClick}
								onActivityDoubleClick={onActivityDoubleClick}
								style={style}
							/>
						</Group>
					) : (
						<Group y={-.5} x={-.5}>
							<GridBG
								columns={style.columns}
								rows={group.labels.length}
								style={style}
							/>
							<ListLabelsVert
								labels={group.labels}
								space={style.space.y}
								align="right"
								margin={5}
								style={style}
							/>
							<Activities
								clip={{ x: 0, y: 0, width: width, height: clipHead }}
								start={start}
								showType={group.show}
								activities={group.activities}
								activityHighlight={activityHighlight}
								activitySelect={activitySelect}
								onActivityEnter={onActivityEnter}
								onActivityLeave={onActivityLeave}
								onActivityClick={onActivityClick}
								onActivityDoubleClick={onActivityDoubleClick}
								style={style}
							/>
							{RenderLeaf(group)}
						</Group>
					)

					// È UN "BRANCH"
				) : (group.groups.map((g: GraphGroup, index: number) => (
					<GraphGroupCmp key={index}
						// questo perche' se è un "branch" visualizza solo l'HEADER quindi non c'e' lo spazio "margin" dei groups
						y={index == 0 ? style.groupMargin : 0}
						deep={deep + 1}

						group={g}
						start={start}
						style={style}
						activityHighlight={activityHighlight}
						activitySelect={activitySelect}

						onGroupChange={newGroup => handleGroupChange(newGroup, index)}
						onActivityEnter={onActivityEnter}
						onActivityLeave={onActivityLeave}
						onActivityClick={onActivityClick}
						onActivityDoubleClick={onActivityDoubleClick}

						HeaderRender={HeaderRender}
						RenderLeaf={RenderLeaf}
					/>
				)))
			)}

		</LayoutCollection>


		{/* {!group.collapsed && group.labels && <Line
			x={x} y={y}
			points={[
				0.5, -style.groupMargin,
				0.5, style.header.height + (group.show == GROUP_SHOW_TYPE.COMPACT ? style.compact.y : style.space.y) * (group.labels.length)
			]}
			stroke="white"
			strokeWidth={1}
		/>} */}


	</>
}

GraphGroupCmp.CalcHeight = ({ group, style }: GraphGroupProps): number => groupsGetHeight(group, style)

GraphGroupCmp.CalcVerticalGap = (style: GraphStyle): number => style.groupMargin + Header.CalcHeight({ style })

export default GraphGroupCmp

interface GraphGroupProps {
	/** il GRAPH-GROUP da visualizzare */
	group: GraphGroup,
	/** la data correntemente visibile al'estrema sinistra del PLANNER */
	start?: DateNumber,
	/** le ACTIVITY in highlight */
	activityHighlight?: Activity[],
	/** L'ACTIVITY selezionata */
	activitySelect?: Activity[],
	/** nell'albero della rappresentazione dei GROUPs indica la profondità del ramo */
	deep?: number,

	style: GraphStyle,
	x?: number,
	y?: number,
	areaHeight?: number,

	onGroupChange?: (newData: GraphGroup) => void,
	onActivityEnter?: (e: KonvaEventObject<MouseEvent>, activity: Activity) => void,
	onActivityLeave?: (e: KonvaEventObject<MouseEvent>, activity: Activity) => void,
	onActivityClick?: (e: KonvaEventObject<MouseEvent>, activity: Activity) => void,
	onActivityDoubleClick?: (e: KonvaEventObject<MouseEvent>, activity: Activity) => void,

	HeaderRender?: (group: GraphGroup) => ReactNode,
	RenderLeaf?: (group: GraphGroup) => ReactNode
}

